"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowseResourceModalDialogBox = void 0;
const ITabNavigator_1 = require("../../core/render/ITabNavigator");
const ModalDialog_1 = require("../../core/render/ModalDialog");
const HtmlWidget_1 = require("../widgets/HtmlWidget");
const HTMLWidgetFormBuilder_1 = require("../../core/render/HTMLWidgetFormBuilder");
const Resource_1 = require("../../core/resourceSystem/Resource");
class BrowseResourceModalDialogBox extends ModalDialog_1.ModalDialog {
    constructor(resourceManager, parentContainer) {
        super(parentContainer);
        this.resourceManager = resourceManager;
        this.selectedResourceId = -1;
        this.preventClickToExit = true;
        this.createDialog();
    }
    createDialog() {
        this.modalBody.element.id = "browseResourceModalBody";
        this.modalFooter.element.id = "browseResourceModalFooter";
        this.modalHeading.createElement("h1", h1 => h1.textContent = "Browse Resource");
        this.tabNavigator = new ITabNavigator_1.TabNavigator();
        let menuDiv = this.modalBody.createElement("div", element => {
            element.classList.add("tab");
            element.id = "browseResourceMenuDiv";
        });
        this.tabNavigator.parentContainer = this.modalBody.renderBody;
        this.tabNavigator.menuDiv = menuDiv.renderBody;
        let urlTab = this.tabNavigator.addTabMenuItem("URL", "urlTab", true, null);
        this.setupUrlTab(urlTab);
        let blobTab = this.tabNavigator.addTabMenuItem("Resource Blob", "blobTab", false, null);
        this.setupBlobTab(blobTab);
        this.createCloseButton();
    }
    addResourceToTable(body, blobResource) {
        let row = body.insertRow();
        let selectCell = row.insertCell();
        let selectInput = document.createElement("input");
        selectInput.type = "radio";
        selectInput.value = `${blobResource.resourceId}`;
        selectInput.id = `radioId-${blobResource.resourceId}`;
        selectInput.name = "resource";
        selectInput.addEventListener("change", () => this.selectedResourceId = blobResource.resourceId);
        selectCell.appendChild(selectInput);
        let nameCell = row.insertCell();
        nameCell.textContent = blobResource.resourceName;
        let fileNameCell = row.insertCell();
        fileNameCell.textContent = blobResource.getBlob().fileName;
        let fileTypeCell = row.insertCell();
        fileTypeCell.textContent = Resource_1.ResourcePurpose[blobResource.resourcePurpose];
        let mimeCell = row.insertCell();
        mimeCell.textContent = blobResource.getBlob().blobData.type;
        let actionCell = row.insertCell();
        let deleteLink = document.createElement("a");
        deleteLink.href = "#";
        deleteLink.text = "Delete";
        deleteLink.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
            evt.preventDefault();
            yield this.resourceManager.deleteResource(blobResource.resourceId);
            body.removeChild(row);
        }));
        actionCell.appendChild(deleteLink);
    }
    addUrlResourceToTable(body, urlResource) {
        let row = body.insertRow();
        let selectCell = row.insertCell();
        let selectInput = document.createElement("input");
        selectInput.type = "radio";
        selectInput.value = `${urlResource.resourceId}`;
        selectInput.id = `radioId-${urlResource.resourceId}`;
        selectInput.name = "resource";
        selectInput.addEventListener("change", () => this.selectedResourceId = urlResource.resourceId);
        selectCell.appendChild(selectInput);
        let nameCell = row.insertCell();
        nameCell.textContent = urlResource.resourceName;
        let urlCell = row.insertCell();
        urlCell.textContent = urlResource.resourceBody;
        let typeCell = row.insertCell();
        typeCell.textContent = Resource_1.ResourcePurpose[urlResource.resourcePurpose];
        let actionCell = row.insertCell();
        let deleteLink = document.createElement("a");
        deleteLink.href = "#";
        deleteLink.text = "Delete";
        deleteLink.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
            evt.preventDefault();
            yield this.resourceManager.deleteResource(urlResource.resourceId);
            body.removeChild(row);
        }));
        actionCell.appendChild(deleteLink);
    }
    setupUrlTab(urlTab) {
        let useButton;
        urlTab.createParagraph("Select a URL resource from the database or create a new URL resource. URL resource must be directly accessible.");
        urlTab.createElement("table", element => {
            let table = element;
            table.innerHTML = `
<thead>
    <tr>
        <th>Select</th>
        <th>Name</th>
        <th>URL</th>
        <th>Type</th>
        <th>Action</th>
    </tr>
</thead>
`;
            let body = table.createTBody();
            this.resourceManager.getAllUrlResources().then(urls => {
                for (let blobResource of urls) {
                    this.addUrlResourceToTable(body, blobResource);
                }
                urlTab.createElement("div", createUrlSection => {
                    createUrlSection.classList.add("group-box");
                    let form = new HtmlWidget_1.HtmlWidget("form", "");
                    form.element.classList.add("form-content");
                    form.shouldAppendChild = true;
                    createUrlSection.appendChild(form.element);
                    let formBuilder = new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(form);
                    let fileInput;
                    formBuilder.addTextInput("Resource Name", "resourceNameInput", true);
                    formBuilder.addUrlInput("URL", "urlInput", true)
                        .addSelect("Type", "fileTypeSelectUrl", true, [{ value: "0", text: "Song" }])
                        .addElement("div", div => {
                        div.classList.add("btn-group-horizontal");
                        let button = document.createElement("button");
                        div.appendChild(button);
                        button.classList.add("btn");
                        button.textContent = "Save";
                        button.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
                            evt.preventDefault();
                            if (!form.element.checkValidity()) {
                                alert("Validation failed: Please check form before submitting.");
                                return;
                            }
                            button.disabled = true;
                            useButton.disabled = true;
                            button.textContent = "Working...";
                            let resource = new Resource_1.Resource();
                            resource.resourceName = form.element.querySelector("#resourceNameInput").value;
                            resource.resourcePurpose = Resource_1.ResourcePurpose.Song;
                            resource.resourceType = Resource_1.ResourceType.Url;
                            resource.resourceBody = form.element.querySelector("#urlInput").value;
                            let newResource = yield this.resourceManager.addResource(resource);
                            resource = null;
                            this.addUrlResourceToTable(body, newResource);
                            button.disabled = false;
                            useButton.disabled = false;
                            button.textContent = "Save";
                        }));
                        useButton = document.createElement("button");
                        div.appendChild(useButton);
                        useButton.classList.add("btn");
                        useButton.textContent = "Use Selected";
                        useButton.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
                            evt.preventDefault();
                            if (this.selectedResourceId === -1) {
                                alert("You must select a URL from the table.");
                                return;
                            }
                            if (this.valueSelected != null) {
                                let resource = yield this.resourceManager.getResource(this.selectedResourceId);
                                this.valueSelected(Resource_1.ResourceType.Url, this.selectedResourceId, resource.resourceName);
                            }
                            this.close();
                        }));
                    });
                });
            });
        });
    }
    setupBlobTab(blobTab) {
        let useButton;
        blobTab.createParagraph("Select a blob resource from the database or upload a new blob resource. A blob URL will be generated for playback.");
        blobTab.createElement("table", element => {
            let table = element;
            table.innerHTML = `
<thead>
    <tr>
        <th>Select</th>
        <th>Name</th>
        <th>File Name</th>
        <th>File Type</th>
        <th>MIME Type</th>
        <th>Action</th>
    </tr>
</thead>
`;
            let body = table.createTBody();
            this.resourceManager.getAllBlobResources().then(blobs => {
                for (let blobResource of blobs) {
                    this.addResourceToTable(body, blobResource);
                }
                blobTab.createElement("div", uploadFileSection => {
                    uploadFileSection.classList.add("group-box");
                    let form = new HtmlWidget_1.HtmlWidget("form", "");
                    form.element.classList.add("form-content");
                    form.shouldAppendChild = true;
                    uploadFileSection.appendChild(form.element);
                    let formBuilder = new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(form);
                    let fileInput;
                    formBuilder.addTextInput("Blob Name", "blobNameInput", true);
                    formBuilder.addFileInput("File to Upload", "fileInputBlob", true, element => {
                        let fileElement = element;
                        fileElement.accept = ".m4a";
                        fileInput = element;
                    })
                        .addSelect("File Type", "fileTypeSelect", true, [{ value: "song", text: "Song" }])
                        .addElement("div", div => {
                        div.classList.add("btn-group-horizontal");
                        let button = document.createElement("button");
                        div.appendChild(button);
                        button.classList.add("btn");
                        button.textContent = "Upload";
                        button.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
                            evt.preventDefault();
                            if (!form.element.checkValidity()) {
                                alert("Validation failed: Please check form before submitting.");
                                return;
                            }
                            button.disabled = true;
                            useButton.disabled = true;
                            button.textContent = "Working...";
                            let file = fileInput.files[0];
                            let resource = new Resource_1.Resource();
                            resource.resourceName = form.element.querySelector("#blobNameInput").value;
                            resource.resourcePurpose = Resource_1.ResourcePurpose.Song;
                            resource.resourceType = Resource_1.ResourceType.Blob;
                            let blobResource = {
                                fileName: file.name,
                                blobData: file
                            };
                            resource.resourceBody = blobResource;
                            let newResource = yield this.resourceManager.addResource(resource);
                            resource = null;
                            this.addResourceToTable(body, newResource);
                            button.disabled = false;
                            useButton.disabled = false;
                            button.textContent = "Upload";
                        }));
                        useButton = document.createElement("button");
                        div.appendChild(useButton);
                        useButton.classList.add("btn");
                        useButton.textContent = "Use Selected";
                        useButton.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
                            evt.preventDefault();
                            if (this.selectedResourceId === -1) {
                                alert("You must select a blob from the table.");
                                return;
                            }
                            if (this.valueSelected != null) {
                                let resource = yield this.resourceManager.getResource(this.selectedResourceId);
                                this.valueSelected(Resource_1.ResourceType.Blob, this.selectedResourceId, resource.resourceName);
                            }
                            this.close();
                        }));
                    });
                });
            });
        });
    }
    createCloseButton() {
        this.modalFooter.createElement("button", button => {
            button.classList.add("btn");
            button.textContent = "Exit";
            button.addEventListener("click", click => this.close());
        });
    }
}
exports.BrowseResourceModalDialogBox = BrowseResourceModalDialogBox;
//# sourceMappingURL=BrowseResourceModalDialogBox.js.map